import { Box } from '../../BaseComponents'

export default Box
export { Box }
